import React, { Component } from 'react';
import videojs from 'video.js';
import { func, shape } from 'prop-types';

class AudioPlayer extends Component {
  componentDidMount() {
    const { setPlayer } = this.props;
    // instantiate Video.js
    setPlayer(videojs(this.audioNode, this.props));
  }

  // destroy player on unmount
  componentWillUnmount() {
    const { playerObject } = this.props;
    if (playerObject) {
      playerObject.dispose();
    }
  }

  setNode(node) {
    this.audioNode = node;
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <div>
        <div data-vjs-player style={{ maxHeight: '30px' }}>
          <audio ref={node => this.setNode(node)} className="video-js" />
        </div>
      </div>
    );
  }
}

AudioPlayer.propTypes = {
  setPlayer: func.isRequired,
  playerObject: shape().isRequired
};

export default AudioPlayer;
